import Box from '@mui/material/Box';
import { colorPalette } from '@repo/mui-config/color-palette';

import { P24MarketingAgreementsFormInputs } from '../form/p24-marketing-agreements-form-inputs';

// Zgody marketingowe P24 widok 0 liberisa
export function P24MarketingAgreementsFormLiberis() {
  return (
    <Box
      sx={{
        marginTop: { xs: 2, sm: '20px', md: '52px', lg: '30px' },
      }}
    >
      <Box
        sx={{
          borderRadius: '10px',
          border: `1px solid ${colorPalette.smoke.light}`,
          paddingY: { xs: '10px', sm: '16px' },
          paddingRight: { xs: '10px', md: '8' },
          paddingLeft: { xs: '10px', md: '24px' },
        }}
      >
        <P24MarketingAgreementsFormInputs withTitle={false} />
      </Box>
    </Box>
  );
}
